<template>
  <section class="web-activity-footer">
    <slot></slot>
    <div class="web-activity-footer__content-wrap">
      <div class="web-activity-footer__desc-wrap">
        <section class="web-activity-footer__desc-left">
          <p class="web-activity-footer__desc">
            {{ leftContent.desc }}
          </p>
          <p class="web-activity-footer__desc-sub">
            {{ leftContent.subDesc }}
          </p>
        </section>
        <section class="web-activity-footer__desc-right">
          <p class="web-activity-footer__desc">
            {{ content.desc }}
          </p>
          <p class="web-activity-footer__desc-sub">
            {{ content.subDesc }}
          </p>
        </section>
      </div>
      <nio-button class="web-activity-footer__act-btn"
                  :class="[disabled ? 'disabled' : '']"
                  @click="$emit('btn-click')">
        {{ text }}
      </nio-button>
    </div>
  </section>
</template>

<script>
import NioButton from '@/components/ui/NioButton';

export default {
  name: 'WebOperationFooter',
  components: {
    NioButton
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    content: {
      type: Object,
      default: () => ({})
    },
    leftContent: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";
@import '../../assets/scss/mixins';

.web-activity-footer {
  position: fixed;
  width: 100vw;
  left: 0;
  bottom: 0;
  padding: sizeTrans($space_20) 0;
  z-index: 10;
  background-color: $color_white_back;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.5);
  font-size: sizeTrans(14);
  line-height: sizeTrans(24);

  &__content-wrap {
    display: flex;
    width: calcPcVw(1120);
    max-width: 1120px;
    margin: 0 auto;
  }

  &__desc-wrap {
    flex: 1;
    display: flex;
    margin-right: sizeTrans($space_20);
  }

  &__desc-left {
    flex: 1;
  }

  &__desc-right {
    flex: 1;
    text-align: right;
  }

  &__desc {
    @include blue_sky_bold;
  }

  &__desc-sub {
  }

  &__act-btn.ui-nio-button {
    // width: sizeTrans(120);
    min-width: sizeTrans(200);
  }

  @include touch {
    padding: sizeTrans(12) 0;
    font-size: sizeTrans(12);
    line-height: sizeTrans(14);

    &__content-wrap {
      width: 100%;
      @include pagePadding();
    }
    &__desc-left {
      display: none;
    }
    &__act-btn.ui-nio-button {
      height: sizeTrans(35);
      line-height: sizeTrans(35);
      font-size: sizeTrans(12) !important;
    }
  }
}
</style>